import { useAppSelector } from 'shared/redux/store';

export const useAddRepresentativesData = () => {
  const { user: userState } = useAppSelector((state) => state); // Getting the users data from redux
  const user = userState?.user || { attributes: { medium_id: '', country_code: 'au' } };
  const country = userState?.user?.attributes?.other_phone_numbers?.find((num) => num.type === 'primary'); // Getting the users country
  const userCountry = country?.country_code || user?.attributes?.country_code || 'au'; // Getting the users country fallback
  const medium_id = user.attributes.medium_id;
  return { userCountry, medium_id };
};
